const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const PHONE_DIGITS_REGEX = /^\d{10}$/;

export function validateEmail(email) {
  const trimmed = String(email ?? '').trim();
  if (!trimmed) return 'Email address is required.';
  if (trimmed.length > 254) return 'Email address is too long.';
  if (!EMAIL_REGEX.test(trimmed)) return 'Please enter a valid email address.';
  return '';
}

export function validatePhone(phone) {
  const digits = String(phone ?? '').replace(/\D/g, '');
  if (!digits) return 'Phone number is required.';
  if (!PHONE_DIGITS_REGEX.test(digits)) {
    return 'Phone number must be exactly 10 digits.';
  }
  return '';
}

export function validateName(name, label = 'Name') {
  const trimmed = String(name ?? '').trim();
  if (!trimmed) return `${label} is required.`;
  if (trimmed.length < 2) return `${label} must be at least 2 characters.`;
  if (trimmed.length > 100) return `${label} is too long (max 100 characters).`;
  return '';
}

export function validateOrganization(organization) {
  const trimmed = String(organization ?? '').trim();
  if (!trimmed) return 'Organization is required.';
  if (trimmed.length > 150) return 'Organization is too long (max 150 characters).';
  return '';
}

export function validateTitle(title) {
  const trimmed = String(title ?? '').trim();
  if (!trimmed) return 'Title is required.';
  if (trimmed.length > 100) return 'Title is too long (max 100 characters).';
  return '';
}

export function validateResolvedService(service) {
  const trimmed = String(service ?? '').trim();
  if (!trimmed) return 'Please select a service.';
  if (trimmed.length > 80) return 'Service name is too long (max 80 characters).';
  return '';
}

export function validateMessage(message) {
  const trimmed = String(message ?? '').trim();
  if (!trimmed) return 'Message is required.';
  if (trimmed.length < 5) return 'Message must be at least 5 characters.';
  if (trimmed.length > 2000) return 'Message must be no more than 2000 characters.';
  return '';
}

/**
 * @param {object} fields - form field values
 * @param {{ nameKey?: 'name' | 'fullname', serviceFieldKey?: string, resolvedService?: string }} options
 * @returns {Record<string, string>}
 */
export function validateEnquiryForm(fields, options = {}) {
  const nameKey = options.nameKey ?? (fields.fullname !== undefined ? 'fullname' : 'name');
  const serviceFieldKey = options.serviceFieldKey ?? 'subject';
  const resolvedService = options.resolvedService ?? '';

  const errors = {};

  const nameError = validateName(fields[nameKey], 'Your name');
  if (nameError) errors[nameKey] = nameError;

  const phoneError = validatePhone(fields.phone);
  if (phoneError) errors.phone = phoneError;

  const emailError = validateEmail(fields.email);
  if (emailError) errors.email = emailError;

  const orgError = validateOrganization(fields.organization);
  if (orgError) errors.organization = orgError;

  const titleError = validateTitle(fields.title);
  if (titleError) errors.title = titleError;

  const serviceError = validateResolvedService(resolvedService);
  if (serviceError) errors[serviceFieldKey] = serviceError;

  const messageError = validateMessage(fields.message);
  if (messageError) errors.message = messageError;

  return errors;
}

export function hasValidationErrors(errors) {
  return Object.keys(errors).length > 0;
}

export function getFirstValidationError(errors) {
  const values = Object.values(errors);
  return values.length > 0 ? values[0] : '';
}
